/*
  Play/pause do video de produto da PDP (ver snippets/md-video-produto.liquid).

  O video nao tem autoplay no atributo de proposito: e o observador daqui que
  da o play quando o slide entra na tela e pausa quando sai - assim o arquivo
  so baixa quando o cliente chega nele, e o loop nao gasta CPU escondido.

  Limiar de 35%: o slider da galeria no celular deixa uma beirada do proximo
  slide aparecendo (grid--peek); com limiar baixo essa beirada ja tocaria o
  video antes do swipe.

  O script pode ser incluido mais de uma vez (um por video renderizado);
  a trava __mdVideoProdutoInit garante que so a primeira execucao liga tudo.
*/
(() => {
  if (window.__mdVideoProdutoInit) return;
  window.__mdVideoProdutoInit = true;

  /*
    DESTRAVA NO TOQUE (06/09/2026).

    O navegador pode RECUSAR o play automatico mesmo com o video mudo e inline. O caso
    mais comum no iPhone e o Modo de Pouca Energia (bateria amarela): com ele ligado o
    iOS bloqueia autoplay de video, e o nosso video, que nao mostra controle nenhum de
    proposito, ficava parado no primeiro quadro sem NENHUMA saida pro cliente. Tambem
    acontece com economia de dados ligada e em algumas politicas de navegador.

    Aqui, quando o play e recusado, o primeiro toque no video liga o video: gesto do
    usuario e sempre aceito, em qualquer modo. Nao muda nada na tela, nao aparece
    controle, e quem tem autoplay liberado nem chega nesta parte do codigo.

    O ouvinte entra uma vez so por video (a marca no dataset evita empilhar um a cada
    entrada na tela) e fica de pe: se o toque tambem falhar, o proximo tenta de novo.
  */
  /*
    O BOTAO DE PLAY (06/09/2026) so nasce quando o autoplay foi RECUSADO - confirmado
    pelo Ivan no iPhone: com Modo de Pouca Energia ligado o video nao toca sozinho, com
    o modo desligado toca normal. Com autoplay liberado nada disto roda: nem o <style>,
    nem o botao, nem o ouvinte de toque. A tela fica exatamente como esta hoje.

    Mora no pai direto do video, que ja e position: relative nos dois componentes
    (.product__media na galeria, .md-videos__midia nos videos de clientes), entao nao
    mexe em layout nenhum. Some sozinho no evento "playing", inclusive quando o video
    volta a tocar por conta propria, e reaparece se um play posterior for recusado de
    novo. O stopPropagation evita que o toque no botao vire clique no cartao em volta.
  */
  const CSS_BOTAO =
    '.md-play-travado.md-play-travado{position:absolute!important;top:50%!important;left:50%!important;right:auto!important;bottom:auto!important;transform:translate(-50%,-50%)!important;z-index:2!important;display:flex!important;align-items:center;justify-content:center;box-sizing:border-box!important;width:64px!important;height:64px!important;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;padding:0!important;margin:0!important;border:0!important;border-radius:50%!important;background:rgba(17,17,17,0.55)!important;color:#fff;cursor:pointer;object-fit:none!important}.md-play-travado.md-play-travado svg{width:28px!important;height:28px!important;margin-left:3px!important;position:static!important}.md-play-travado.md-play-travado[hidden]{display:none!important}';

  const estiloDoBotao = () => {
    if (document.getElementById('md-play-travado-estilo')) return;
    const e = document.createElement('style');
    e.id = 'md-play-travado-estilo';
    e.textContent = CSS_BOTAO;
    document.head.appendChild(e);
  };

  const tentarTocar = (video) => {
    video.muted = true;
    video.playsInline = true;
    const tocada = video.play();
    if (tocada) tocada.catch(() => {});
  };

  const botaoDePlay = (video) => {
    const pai = video.parentElement;
    let botao = pai.querySelector('.md-play-travado');
    if (botao) return botao;
    estiloDoBotao();
    botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'md-play-travado';
    botao.setAttribute('aria-label', 'Play video');
    botao.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>';
    botao.addEventListener('click', (evento) => {
      evento.stopPropagation();
      tentarTocar(video);
    });
    video.addEventListener('playing', () => {
      botao.hidden = true;
    });
    pai.appendChild(botao);
    return botao;
  };

  const destravarNoToque = (video) => {
    botaoDePlay(video).hidden = false;
    if (video.dataset.mdToquePraTocar) return;
    video.dataset.mdToquePraTocar = '1';
    video.addEventListener('click', () => tentarTocar(video));
  };

  const ligar = () => {
    const videos = document.querySelectorAll('.md-video-produto video');
    if (!videos.length) return;

    const observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          const video = entrada.target;
          if (entrada.isIntersecting) {
            /* mudo + inline reafirmados por propriedade: e o que o iOS exige
               pra aceitar play() sem gesto do usuario */
            video.muted = true;
            video.playsInline = true;
            const tocada = video.play();
            if (tocada) tocada.catch(() => destravarNoToque(video));
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.35 }
    );

    videos.forEach((video) => observador.observe(video));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
})();
